/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tenant_Selection_TitleInputs */

const es_tenant_selection_title = /** @type {(inputs: Tenant_Selection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Seleccionar tenant`)
};

const en_tenant_selection_title = /** @type {(inputs: Tenant_Selection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Select tenant`)
};

/**
* | output |
* | --- |
* | "Nexata \| Select tenant" |
*
* @param {Tenant_Selection_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tenant_selection_title = /** @type {((inputs?: Tenant_Selection_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tenant_Selection_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tenant_selection_title(inputs)
	return en_tenant_selection_title(inputs)
});
export { tenant_selection_title as "tenant-selection.title" }